// extracted by mini-css-extract-plugin
module.exports = {"search_container":"FreeTextSearchInput_search_container__R_Ekh","search_icon":"FreeTextSearchInput_search_icon__izXgT","search_input":"FreeTextSearchInput_search_input__2k501"};